// How an issue reads in a detail view — the web drawer's and the phone sheet's.

import type { IIssue } from '../../trusstor/index.js';
import type { IListItem } from '../activities/model/listItem.js';

/** Distinct floor nicknames for an issue's locations, comma-joined (e.g. "3F, 4F"). */
export function formatIssueLocations(locations: NonNullable<IIssue['locations']>): string {
  return [...new Map(locations.map((l) => [l.floor.floorId, l.floor.floorNick] as const)).values()].join(', ');
}

/**
 * The title of the task an issue was raised against, when the list holds that
 * task. `taskId` is D-ORCA's own field on the issue (the wire type predates it,
 * hence the read through `unknown`).
 */
export function linkedTaskTitle(issue: IIssue | undefined, items: readonly IListItem[]): string | undefined {
  const taskId: unknown = issue?.taskId;
  if (typeof taskId !== 'string') return undefined;
  return items.find((item) => item.raw.activity?.id === taskId)?.title;
}
